module.exports = __webpack_public_path__ + "img/GDQ-matcirkel_40.68b27c14.gif";